import { useNavigation } from "@react-navigation/native";
import { Formik } from "formik";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import ScreenNames from "../../constants/routeNames";
import { getNextScreen } from "../../navigation/simpleOnboardingFlow";
import { selectDietGoals, setDietGoals } from "../../slices/simpleOnboardingSlice";
import SelectionScreen, { type Option } from "../New_DIY_form/SelectionScreen";

const SimpleOnboardingDietGoalsScreen = (): JSX.Element => {
  const { t } = useTranslation();
  const navigation = useNavigation();
  const dispatch = useDispatch();

  const selectedDietGoals = useSelector(selectDietGoals);

  const options: Option[] = [
    {
      value: "HIGH_PROTEIN",
      label: t("simple_onboarding.diet_goals.HIGH_PROTEIN"),
      description: "",
      icon: "Egg",
      iconType: "lucide",
    },
    {
      value: "LOW_CARB",
      label: t("simple_onboarding.diet_goals.LOW_CARB"),
      description: "",
      icon: "Wheat",
      iconType: "lucide",
    },
    {
      value: "LOW_CALORIE",
      label: t("simple_onboarding.diet_goals.LOW_CALORIE"),
      description: "",
      icon: "Heart",
      iconType: "lucide",
    },
    {
      value: "HIGH_FIBER",
      label: t("simple_onboarding.diet_goals.HIGH_FIBER"),
      description: "",
      icon: "Leaf",
      iconType: "lucide",
    },
    {
      value: "LOW_FAT",
      label: t("simple_onboarding.diet_goals.LOW_FAT"),
      description: "",
      icon: "Milk",
      iconType: "lucide",
    },
  ];

  return (
    <Formik
      initialValues={{ dietGoals: selectedDietGoals || [] }}
      onSubmit={(values) => {
        dispatch(setDietGoals(values.dietGoals));
        const nextScreen = getNextScreen(ScreenNames.SimpleOnboarding_3b_DietGoals);
        if (nextScreen) {
          navigation.navigate(nextScreen as never);
        }
      }}
    >
      {({ values, setFieldValue, handleSubmit }) => (
        <SelectionScreen
          title={t("simple_onboarding.diet_goals.title")}
          subtitle={t("simple_onboarding.diet_goals.subtitle")}
          options={options}
          multipleSelection={true}
          selectedOptions={values.dietGoals}
          setSelectedOptions={(goals) => setFieldValue("dietGoals", goals)}
          onPressNext={handleSubmit}
          onPressBack={() => navigation.goBack()}
          nextButtonDisabled={false} // Allow skipping this screen
          nextButtonTestIdPostfix="diet-goals"
        />
      )}
    </Formik>
  );
};

export default SimpleOnboardingDietGoalsScreen;
